import { createEvent, restore, sample } from 'effector'

import { fx } from 'src/libs'
import { Partner, PartnerRequest, PartnerResponse } from './types'
import { dateColumns } from 'src/libs/general'

export const partnersListMounted = createEvent<PartnerRequest>()

export const getPartners = fx<PartnerRequest, PartnerResponse>({
  method: 'GET',
  url: `/partner`,
})

export const $partners = restore<Partner[]>(
  getPartners.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPartners = restore(
  getPartners.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: partnersListMounted,
  fn: ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy != '') {
      if (orderBy.constructor === Array) {
        // @ts-ignore
        orderBy = orderBy.join('.')
      }
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      const newFilters = {
        ...filters,
        status: filters.status?.map((item) => `${item}`),
      }

      // Список полей, которые не нужно конвертировать в строку
      const fieldsToKeepAsIs = [
        'country',
        'status',
        'beginPeriodAt',
        'endPeriodAt',
        'client.region',
      ]

      let newObj = Object.keys(newFilters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = fieldsToKeepAsIs.includes(key)
            ? filters[key as keyof typeof filters]
            : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (searchText) {
        if (typeof searchText == 'string') {
          const newSearchedColumn =
            searchedColumn === 'client'
              ? `${searchedColumn}.email`
              : searchedColumn
          newObj[newSearchedColumn] = searchText.toLowerCase()
        }

        if (dateColumns.includes(searchedColumn)) {
          newObj[searchedColumn] = [
            // @ts-ignore
            searchText[0].format('YYYY-MM-DD'),
            // @ts-ignore
            searchText[1].format('YYYY-MM-DD'),
          ]
        }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }
    return {
      query,
    }
  },
  target: getPartners,
})
